"use client";

import { Megaphone } from "lucide-react";
import { ComingSoonGate } from "@/app/_module/components/ComingSoonGate";
import { MARKETING_FEATURES } from "@/app/_module/constants/comingSoon";
import { marketingUnlockedFor } from "@/app/_module/utils/featureFlags";
import { useUserContext } from "@/app/_module/store/contexts/userContext";
import MarketingWorkspace from "./_modules/MarketingWorkspace";

export default function MarketingPage() {
  const { user } = useUserContext();
  if (marketingUnlockedFor(user?.user)) return <MarketingWorkspace />;
  return (
    <ComingSoonGate
      icon={Megaphone}
      title="Marketing"
      message="Campaigns featuring you, managed by Licensedproducer. Choose your budget, approve your creative, and follow your results here."
      features={MARKETING_FEATURES}
      waitlistKey="marketingWaitlist"
    >
      <MarketingWorkspace />
    </ComingSoonGate>
  );
}
